module.exports = __webpack_public_path__ + "img/users.bdc90467.png";